module.exports = __webpack_public_path__ + "static/media/new-message.29df2bbf.svg";